import { useState, useEffect } from "react";
import { X, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

interface CompareAllBarProps {
  listingId: string;
}

const DISMISSED_KEY = "fxa_compare_dismissed";

export default function CompareAllBar({ listingId }: CompareAllBarProps) {
  const [show, setShow] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    const dismissed = JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || "{}");
    if (dismissed[listingId]) return;

    const timer = setTimeout(() => setShow(true), 8000);
    return () => clearTimeout(timer);
  }, [listingId]);

  function dismiss() {
    setShow(false);
    const dismissed = JSON.parse(sessionStorage.getItem(DISMISSED_KEY) || "{}");
    dismissed[listingId] = true;
    sessionStorage.setItem(DISMISSED_KEY, JSON.stringify(dismissed));
  }

  if (!show) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 md:bottom-4 md:left-4 md:right-4">
      <div className="mx-auto max-w-3xl flex items-center justify-between gap-3 rounded-t-xl md:rounded-xl bg-[hsl(210_53%_23%)] px-4 py-3 shadow-lg">
        <button
          onClick={() => nav("/finance-demo")}
          className="flex items-center gap-2 text-[hsl(40_55%_51%)] text-sm font-body font-medium hover:underline"
        >
          See all payment options for this listing
          <ArrowRight className="h-4 w-4" />
        </button>
        <button onClick={dismiss} className="text-white/60 hover:text-white" aria-label="Dismiss">
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
